import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { useHostServices } from '@/composables/format-edit/useHostServices'
import { useEnglishResumeFormatData } from '@/composables/format-edit/useEnglishResumeFormatData'

type ResumeFormLib = {
  dateWithoutTime: (date: Date | string | null | undefined) => number | string
  getToday: () => Date
  getTommorow: () => Date
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumeCreateDateCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const { formLib: formLibRaw } = useHostServices()
const formLib = formLibRaw as typeof formLibRaw & ResumeFormLib
const formatData = useEnglishResumeFormatData()

const isTodaySelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getToday())
)

const isTomorrowSelected = computed(
  () =>
    formLib.dateWithoutTime(formatData.createDate) ===
    formLib.dateWithoutTime(formLib.getTommorow())
)

function setToday() {
  formatData.createDate = formLib.getToday()
}

function setTomorrow() {
  formatData.createDate = formLib.getTommorow()
}

return { __sfc: true,formLibRaw, formLib, formatData, isTodaySelected, isTomorrowSelected, setToday, setTomorrow }
}

})